import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Truck, Package, Car, Home, Wrench, Users, Baby, Sparkles, ChefHat, Linkedin, Youtube, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="bg-emerald-950 text-white" data-testid="footer">
      <div className="section-container py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_deliverstack/artifacts/2v9gvns2_EB4BFD0D-4C9D-43F2-B0D8-4B4D0DF14E28_1_201_a.jpeg" 
                alt="Stack Logo" 
                className="h-10 w-auto rounded-lg"
              />
            </Link>
            <p className="text-stone-400 leading-relaxed">
              An all-in-one platform that connects businesses and individuals with reliable, on-demand logistics services.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/cargo" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Truck className="w-4 h-4" /> Cargo Delivery
                </Link>
              </li>
              <li>
                <Link to="/courier" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Package className="w-4 h-4" /> Courier
                </Link>
              </li>
              <li>
                <Link to="/towing" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Car className="w-4 h-4" /> Towing
                </Link>
              </li>
              <li>
                <Link to="/nanny" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Baby className="w-4 h-4" /> Nanny
                </Link>
              </li>
              <li>
                <Link to="/cleaning" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Sparkles className="w-4 h-4" /> Cleaning
                </Link>
              </li>
              <li>
                <Link to="/private-chef" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <ChefHat className="w-4 h-4" /> Private Chef
                </Link>
              </li>
              <li>
                <Link to="/movers" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Home className="w-4 h-4" /> Movers
                </Link>
              </li>
              <li>
                <Link to="/roadside-assistance" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Wrench className="w-4 h-4" /> Roadside Assistance
                </Link>
              </li>
              <li>
                <Link to="/laborer" className="text-stone-400 hover:text-lime-400 transition-colors flex items-center gap-2">
                  <Users className="w-4 h-4" /> Laborer
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/business" className="text-stone-400 hover:text-lime-400 transition-colors">
                  For Business
                </Link>
              </li>
              <li>
                <Link to="/insurance" className="text-stone-400 hover:text-lime-400 transition-colors">
                  Insurance & Safety
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-stone-400 hover:text-lime-400 transition-colors">
                  Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-stone-400">
                <Mail className="w-5 h-5 text-lime-400" />
                info@stackcartcorp.com
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <Phone className="w-5 h-5 text-lime-400" />
                905-431-0103
              </li>
              <li className="flex items-center gap-3 text-stone-400">
                <MapPin className="w-5 h-5 text-lime-400" />
                Toronto, Ontario
              </li>
            </ul>

            <h4 className="font-semibold text-lg mt-6 mb-4">Follow Us</h4>
            <div className="flex items-center gap-3" data-testid="social-links">
              <a
                href="https://www.linkedin.com/in/stack-mobility-4a7703400?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-stone-400 hover:bg-lime-400 hover:text-emerald-950 transition-all"
                data-testid="social-linkedin"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com/@stackmobility?si=dqgxKMEgJ2m2zHik"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-stone-400 hover:bg-lime-400 hover:text-emerald-950 transition-all"
                data-testid="social-youtube"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/stackmobility?igsh=cm9wMzZvN2RlMTBj&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-stone-400 hover:bg-lime-400 hover:text-emerald-950 transition-all"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com/@stackmobility?si=dqgxKMEgJ2m2zHik"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-stone-400 hover:bg-lime-400 hover:text-emerald-950 transition-all"
                data-testid="social-x"
                aria-label="X"
              >
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            &copy; {new Date().getFullYear()} Stack. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-stone-500 hover:text-white text-sm transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-stone-500 hover:text-white text-sm transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
